import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { PermissaoService } from './core/services/permissao.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { environment } from '../environments/environment';
import { firstValueFrom } from 'rxjs';

function initPermissoes(permissaoService: PermissaoService) {
  return () =>
    firstValueFrom(permissaoService.carregarPermissoes(environment.aplicacaoId));
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    provideHotToastConfig({
      position: 'top-right',
      dismissible: true,
      autoClose: true,
      duration: 4000,
    }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        errorInterceptor,
        loadingInterceptor
      ])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initPermissoes,
      deps: [PermissaoService],
      multi: true,
    },
  ]
};
